module.exports = __webpack_public_path__ + "static/media/Obsidian Destroyer.9b880301.png";